import React from 'react';

type AppDownloadButtonProps = {
  href: string | null;
  className: string;
  disabledClassName?: string;
  children: React.ReactNode;
  openInNewTab?: boolean;
};

export default function AppDownloadButton({
  href,
  className,
  disabledClassName,
  children,
  openInNewTab = false,
}: AppDownloadButtonProps) {
  if (href) {
    return (
      <a
        href={href}
        target={openInNewTab ? '_blank' : undefined}
        rel={openInNewTab ? 'noreferrer' : undefined}
        className={className}
      >
        {children}
      </a>
    );
  }

  return (
    <span
      aria-disabled="true"
      className={disabledClassName || `${className} cursor-not-allowed opacity-50`}
    >
      {children}
    </span>
  );
}
